import axios from 'axios';
import { BUILDER_TYPE, BUILDER_USER_TYPE, FORM_TYPE } from "../../constants/custom-define-type";
import { MAP_DIALOG_SECTION } from "../../constants/field-types";
import { deduplicateArrayOfObject } from "../../utils/array-handling";

const state = {
  profileBuilderList: null,
  candidateBuilderList: null, // Profile builder list for candidate
  clientBuilderList: null, // Profile builder list for client
};

const mutations = {
  setProfileBuilderList(state, payload) {
    if (payload == null) {
      state.profileBuilderList = null;
      state.candidateBuilderList = null;
      state.clientBuilderList = null;
    } else {
      state.profileBuilderList = payload;
      state.candidateBuilderList = payload.filter(builder => builder.user_type === BUILDER_USER_TYPE.CANDIDATE);
      state.clientBuilderList = payload.filter(builder => builder.user_type === BUILDER_USER_TYPE.CLIENT);
    }
  },
  setCandidateBuilderList(state, payload) {
    if (payload == null) {
      state.candidateBuilderList = null;
    } else {
      state.candidateBuilderList = payload;
      if (state.profileBuilderList == null || state.profileBuilderList.length === 0) {
        state.profileBuilderList = payload;
      }
    }
  },
  setClientBuilderList(state, payload) {
    if (payload == null) {
      state.clientBuilderList = null;
    } else {
      state.clientBuilderList = payload;
      if (state.profileBuilderList == null || state.profileBuilderList.length === 0) {
        state.profileBuilderList = payload;
      }
    }
  },
};

const actions = {
  setProfileBuilderList({ commit }, payload) {
    commit("setProfileBuilderList", payload);
  },
  setCandidateBuilderList({ commit }, payload) {
    commit("setCandidateBuilderList", payload);
  },
  setClientBuilderList({ commit }, payload) {
    commit("setClientBuilderList", payload);
  },
  reloadProfileBuilderList({ commit, rootState }) {
    return new Promise(async (resolve) => {
      if (!rootState.authentication.agencyID) {
        commit("setProfileBuilderList", null);
        resolve();
        return;
      }
      const res = await axios.get(
        "/api/profilesections/?agency=" +
        rootState.authentication.agencyID.toString()
      );
      commit("setProfileBuilderList", res.data);
      resolve();
    });
  },
  loadProfileBuilderList({ state, commit, rootState }) {
    return new Promise(async (resolve) => {
      if (state.profileBuilderList && state.profileBuilderList.length) {
        resolve();
        return;
      }
      if (!rootState.authentication.agencyID) {
        commit("setProfileBuilderList", null);
        resolve();
        return;
      }
      const res = await axios.get(
        "/api/profilesections/?agency=" +
        rootState.authentication.agencyID.toString()
      );
      commit("setProfileBuilderList", res.data);
      resolve();
    });
  },

};

const getters = {
  listScheduleMeetingFormFieldsDefault() {
    return [
      {
        label: "Header",
        type: FORM_TYPE.HTML,
        html: `<h2>Thanks for letting us know you are interested!</h2>
        <p>The next step is for us to schedule a meeting with you and the candidate. Please fill in this form:</p>`
      },
      {
        label: "Would you prefer to start with a virtual meeting or in person? If virtual, please let us know if you have a preferred platform (Zoom, FaceTime, phone call, etc.)",
        labelDetail: "Client Interview Preference",
        type: FORM_TYPE.TEXTBOX,
        model: "text1",
        isRequired: false,
        isOptional: true
      },
      {
        label: "Please let us know some upcoming days and times when you are available",
        labelDetail: "Client Interview Availability",
        type: FORM_TYPE.TEXTAREA,
        model: "text2",
        isRequired: false,
        isOptional: true
      }
    ]
  },
  listJobApplicationFieldsDefault() {
    return [
      {
        label: "Application Notes",
        description: "This is optional, please mention anything specific you'd like us to know.",
        type: FORM_TYPE.TEXT_EDITOR,
        model: "message",
        isRequired: false,
        isOptional: true
      },
      {
        type: FORM_TYPE.VIDEO,
        model: "video_id",
        isRequired: false,
        isOptional: true,
        videoType: "Candidate Job Application",
        videoUrlModel: "video_url",
        label: "Application Video",
        description: "",
      }
    ]
  },
  listPlacementJobFieldsDefault(state, getters, rootState, rootGetters) {
    let result = [
      {
        label: "How much revenue was generated from this job? (Admin Only)",
        model: "revenue",
        type: FORM_TYPE.TEXTBOX,
        isRequired: false,
        isOptional: true,
        isAdminOnly: true
      },
      {
        label: "Date Revenue Generate? (Admin Only)",
        model: "date_revenue_generate",
        type: FORM_TYPE.DATEPICKER,
        isOptional: true,
        isRequired: false,
        isAdminOnly: true
      },
      {
        label: "Title",
        model: "title",
        type: FORM_TYPE.TEXTBOX,
        isRequired: false,
        isOptional: true,
      }
    ];
    if (rootGetters.listPlacementJobTypes && rootGetters.listPlacementJobTypes.length) {
      result.push({
        label: "Job Categories",
        model: "types",
        optionList: rootGetters.listPlacementJobTypes,
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        isRequired: false,
        isOptional: true,
      })
    }
    result = [...result, ...[{
      keyLangLabel: "LABELS.ADDRESS",
      model: "address1",
      type: FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true,
    },
    {
      keyLangLabel: "LABELS.CITY",
      model: "city",
      type: FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true,
    },
    {
      keyLangLabel: "LABELS.STATE",
      model: "provincestate",
      type: FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true,
    },
    {
      keyLangLabel: "LABELS.COUNTRY",
      model: "country",
      type: FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true,
    },
    {
      keyLangLabel: "LABELS.ZIP_CODE",
      model: "postal_code",
      type: FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true,
    }]];
    if (rootGetters.agencyLocations && rootGetters.agencyLocations.length) {
      result.push({
        keyLangLabel: "LABELS.LOCATIONS",
        model: "locations",
        optionList: rootGetters.agencyLocations,
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        isRequired: false,
        isOptional: true,
      })
    }
    result = [...result, ...[{
      label: "Compensation",
      model: "compensation",
      type: FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true,
    },
    {
      label: "Start Date",
      model: "start_date_text",
      type: FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true,
    }]];

    if (rootGetters.agencyType === "Nanny and Household Staffing") {
      const list2 = [
        {
          label: "Children",
          type: FORM_TYPE.TEXTAREA,
          model: "children_description",
          isRequired: false,
          isOptional: true,
        },
        {
          label: "Schedule",
          type: FORM_TYPE.TEXTAREA,
          model: "text",
          isRequired: false,
          isOptional: true,
        },
      ];
      result = [...result, ...list2];
    }

    const list3 = [
      {
        keyLangLabel: "LABELS.DESCRIPTION",
        type: FORM_TYPE.TEXT_EDITOR,
        model: "description",
        isRequired: false,
        isOptional: true,
      },
      {
        label: "Upload Picture",
        type: FORM_TYPE.FILE,
        model: "file1",
        isRequired: false,
        isOptional: true,
      },
    ];
    result = [...result, ...list3];

    if (rootGetters.agencyType === "Nanny and Household Staffing") {
      result.push(
        {
          type: FORM_TYPE.HTML,
          html: `<a
            href="https://drive.google.com/drive/folders/1sxMb-urKv_6AV6oAi0ULip_x5uwiETMS?usp=sharing"
            target="_blank"
            class="mylisting-button dark-button"
            >View Photo Bank</a
          >`,
        }
      )
    }

    result.push(
      {
        type: FORM_TYPE.CHECKBOX_ITEM,
        label: "Hide from job board",
        model: "hide_from_job_board",
        isRequired: false,
      },
      {
        type: FORM_TYPE.CHECKBOX_ITEM,
        label: "Make visible to candidates in dashboard",
        model: "visible_to_candidates",
        isRequired: false,
        showIf: "hide_from_job_board",
        showIfValue: "Yes"
      })
    return result;
  },
  placementJobBuilder(state, getters, rootState, rootGetters) {
    const builderList = rootGetters.profileBuilderList;
    if (builderList) {
      return builderList.find(builder => builder.type === BUILDER_TYPE.PLACEMENT_JOB);
    }
    return null;
  },
  listPlacementJobFields(state, getters, rootState, rootGetters) {
    const builderList = rootGetters.profileBuilderList;
    if (builderList) {
      const placementJobBuilder = builderList.find(builder => builder.type === BUILDER_TYPE.PLACEMENT_JOB);
      if (placementJobBuilder && placementJobBuilder.list_fields && placementJobBuilder.list_fields.length) {
        return placementJobBuilder.list_fields;
      }
    }
    return getters.listPlacementJobFieldsDefault;
  },
  listReferenceFields(state, getters, rootState, rootGetters) {
    const builderList = rootGetters.profileBuilderList;
    if (builderList) {
      const listReferenceBuilder = builderList.filter(builder => builder.type === BUILDER_TYPE.SECTION && builder.api === MAP_DIALOG_SECTION.Reference.api);
      let result = [];
      for (const builder of listReferenceBuilder) {
        if (builder.list_fields) {
          result = [...result, ...builder.list_fields.filter(field => field.model)];
        }
      }
      return deduplicateArrayOfObject(result, 'model');
    }
    return [];
  },
  // map booking label field => booking category
  mapBookingFieldLabelCategory(state, getters, rootState, rootGetters) {
    const builderList = rootGetters.profileBuilderList;
    const result = {};
    if (builderList) {
      const profileBuilderList = builderList.filter(builder => builder.type === BUILDER_TYPE.PROFILE && builder.user_type === BUILDER_USER_TYPE.CLIENT);
      for (const builder of profileBuilderList) {
        if (builder.list_fields) {
          const bookingFields = builder.list_fields.filter(field => field.type === FORM_TYPE.BOOKING_SECTION);
          for (const bookingField of bookingFields) {
            if (bookingField.categoryList) {
              result[bookingField.label] = bookingField.categoryList;
            }
          }
        }
      }
    }
    return result;
  },
  listBuilderConditionKeys() {
    return [
      {
        varKey: 'listRejectConditions',
        apiKey: 'reject_conditions'
      },
      {
        varKey: 'listTypeConditions',
        apiKey: 'type_conditions'
      },
      {
        varKey: 'listStatusConditions',
        apiKey: 'status_conditions'
      },
      {
        varKey: 'listSecondStatusConditions',
        apiKey: 'second_status_conditions'
      },
      {
        varKey: 'listTagConditions',
        apiKey: 'tag_conditions'
      },
      {
        varKey: 'listKeapTagConditions',
        apiKey: 'keap_tag_conditions'
      },
      {
        varKey: 'listLocationConditions',
        apiKey: 'location_conditions'
      },
      {
        varKey: 'listManagerConditions',
        apiKey: 'manager_conditions'
      },
      {
        varKey: 'listSecondManagerConditions',
        apiKey: 'second_manager_conditions'
      },
      {
        varKey: 'listMembershipConditions',
        apiKey: 'membership_conditions'
      },
      {
        varKey: 'listChecklistConditions',
        apiKey: 'checklist_conditions'
      },
      {
        varKey: 'listBadgeConditions',
        apiKey: 'badge_conditions'
      },
      {
        varKey: 'listErrorConditions',
        apiKey: 'error_conditions'
      }
    ]
  },
  listExcludeFieldTypeInProfile() {
    return [FORM_TYPE.PLACEMENT_JOB_SELECTION]
  },
  profileBuilderList(state) {
    return state.profileBuilderList || [];
  },
  candidateBuilderList(state) {
    return state.candidateBuilderList || [];
  },
  clientBuilderList(state) {
    return state.clientBuilderList || [];
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/builders.js